export class TableField {
    uuid: string;
    nombre: string;
    nombre_en: string;
    nombre_es: string;
    codigo: string;
    tipo: string;
    isUnique: boolean;
    isEditable: boolean;
    hidden: boolean;
    codigo_df: string;
    isRequired: boolean;
    childField: TableField[];
}